import { useEffect, useState, useCallback } from "react";
import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import CookieBanner from "./components/CookieBanner";
import LeadCaptureModal from "./components/LeadCaptureModal";
import AnnouncementBanner from "./components/AnnouncementBanner";
import HomePage from "./pages/HomePage";
import UniversitiesPage from "./pages/UniversitiesPage";
import CompaniesPage from "./pages/CompaniesPage";
import AboutPage from "./pages/AboutPage";
import ProgrammesPage from "./pages/ProgrammesPage.tsx";
import CSProgrammePage from "./pages/CSProgrammePage.jsx";
import PlacementTracksPage from "./pages/PlacementTracksPage.jsx";
import CareersPage from "./pages/CareersPage";
import WaitlistPage from "./pages/WaitlistPage";
import LegalPage from "./pages/LegalPage";
import BTechEnrollmentPage from "./pages/BTechEnrollmentPage";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "instant",
        });
    }, [pathname]);
    return null;
}

function ApplyRoute({ onApply }) {
    useEffect(() => { onApply(); }, []);
    return <HomePage />;
}

function App() {
    const [bannerVisible, setBannerVisible] = useState(true);
    const [bannerHeight, setBannerHeight] = useState(44);
    const [leadModalKey, setLeadModalKey] = useState(0);

    const handleApplyNow = useCallback(() => {
        setLeadModalKey((k) => k + 1);
    }, []);

    return (
        <div className="App bg-background min-h-screen overflow-x-hidden">
            <BrowserRouter basename="/">
                <ScrollToTop />
                <AnnouncementBanner
                    onVisibilityChange={setBannerVisible}
                    onApplyNow={handleApplyNow}
                    onHeightChange={setBannerHeight}
                />
                <Navbar
                    bannerVisible={bannerVisible}
                    bannerHeight={bannerHeight}
                />
                {/* Flow spacer: reserves the fixed banner's height so page
                    content clears the (taller) header when the banner is shown,
                    and collapses to 0 — back to normal — when it's dismissed. */}
                <div
                    aria-hidden="true"
                    style={{
                        height: bannerVisible ? bannerHeight : 0,
                        transition: "height 0.3s ease",
                    }}
                />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/apply" element={<ApplyRoute onApply={handleApplyNow} />} />
                    <Route path="/programmes" element={<ProgrammesPage />} />
                    <Route path="/cs-programme" element={<CSProgrammePage />} />
                    <Route
                        path="/placement-tracks"
                        element={<PlacementTracksPage />}
                    />
                    {/* <Route
                        path="/universities"
                        element={<UniversitiesPage />}
                    /> */}
                    {/* <Route path="/companies" element={<CompaniesPage />} /> */}
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="/waitlist" element={<WaitlistPage />} />
                    <Route path="/btech-enroll" element={<BTechEnrollmentPage />} />
                    <Route path="/legal/:slug" element={<LegalPage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
                <Footer />
                <Chatbot />
                <CookieBanner />
                <LeadCaptureModal
                    key={leadModalKey}
                    instantOpen={leadModalKey > 0}
                />
                <Toaster position="bottom-right" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
